import React, { useContext } from 'react';
import { arrayOf, string } from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames';
import { ACTION, NO_RENTAL, NO_RENTAL_URL, RENTAL_INTENT_POD_CHECK_AVAILABILITY } from '../util/constants';
import { publish } from '../analytics';
import styles from '../styles/rental-intent-no-results.module.scss';

const RentalIntentNoResults = ({ productTypes }) => {

  const { channel } = useContext(ExperienceContext);

  const onClick = ({
    podPosition,
    podInteractionNumber
  }) => {

    publish(RENTAL_INTENT_POD_CHECK_AVAILABILITY, {
      podType: NO_RENTAL,
      podAction: ACTION,
      podInteractionNumber,
      podPosition
    });
  };

  if (channel === 'mobile') {
    return (
      <div className={classNames(styles['rental-intent__no-results-mobile'])}>
        <div className={classNames(styles['rental-intent__no-results-mobile__inner'])}>
          <div className={classNames(styles['rental-intent__no-results-mobile__copy'])}>
            We don&apos;t currently rent {productTypes.map((productType) => productType)}.
          </div>
          <div>
            <a
              className="bttn-outline bttn-outline--primary"
              href={NO_RENTAL_URL}
              onClick={() => {
                onClick({
                  podPosition: 'r1',
                  podInteractionNumber: '1',
                  url: NO_RENTAL_URL
                });
              }}
            >
              <span className="bttn__content">View other rentals</span>
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles['rental-intent__no-results'])}>
      <div className={classNames(styles['rental-intent__no-results__inner'])}>
        <Col fallback={9} className={classNames(styles['rental-intent__no-results__copy'])}>
          We don&apos;t currently rent {productTypes.map((productType) => productType)}.
        </Col>
        <Col fallback={3}>
          <a
            className="bttn-outline bttn-outline--primary"
            href={NO_RENTAL_URL}
            onClick={() => {
              onClick({
                podPosition: 'r1',
                podInteractionNumber: '1',
                url: NO_RENTAL_URL
              });
            }}
          >
            <span className="bttn__content">View other rentals</span>
          </a>
        </Col>
      </div>
    </div>
  );
};

RentalIntentNoResults.displayName = 'RentalIntentNoResults';

RentalIntentNoResults.propTypes = {
  productTypes: arrayOf(string).isRequired
};

export { RentalIntentNoResults };
